<template>
  <div>
    <v-btn color="secondary" class="ma-2" outlined @click.native.stop.prevent="toggleModal" id="missionRestoreModal">
      Restore
    </v-btn>
    <v-dialog v-model="isRestoreModalOpen" max-width="630px" persistent>
      <v-toolbar dark color="primary" class="d-flex justify-center align-center">
        <v-toolbar-title class="body-heading-small">Restore Quest</v-toolbar-title>
      </v-toolbar>
      <v-card tile class="modal-content-container">
        <v-card-title>
          <span class="body-heading-small">Please enter new deadline:</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isMissionRestoreFormValid" ref="restoreMissionForm" @submit.prevent="restoreMission">
            <v-row>
              <v-col cols="12" md="12">
                <v-menu ref="menu" v-model="isMissionDueDatePickerOpen" :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="missionDueDate" label="Deadline" outlined dense readonly v-on="on" required :rules="requiredFieldRules"></v-text-field>
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="missionDueDate"
                    :min="
                      this.$moment()
                        .toISOString(true)
                        .substr(0, 10)
                    "
                    @change="selectMissionDueDate"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row class="px-0 justify-space-between">
              <v-btn class="modal-btn" color="secondary" type="submit" :disabled="!isMissionRestoreFormValid">
                Save
              </v-btn>
              <v-btn class="modal-btn" color="secondary" outlined @click="toggleModal">Close</v-btn>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: "RestoreMissionModal",
    data() {
      return {
        isMissionRestoreFormValid: false,
        isRestoreModalOpen: false,
        isMissionDueDatePickerOpen: false,
        missionDueDate: "",
        requiredFieldRules: [(v) => !!v || "Field cannot be empty."],
      };
    },
    props: {
      missionId: {
        type: [String, Number],
        required: true,
      },
    },
    methods: {
      reset() {
        this.isMissionRestoreFormValid = false;
        this.isMissionDueDatePickerOpen = false;
        this.missionDueDate = "";
      },

      selectMissionDueDate(date) {
        this.$refs.menu.save(date);
      },

      toggleModal() {
        this.isRestoreModalOpen = !this.isRestoreModalOpen;
        this.reset();
      },

      restoreMission() {
        this.$store.commit("setLoadingStatus", true);

        this.$http
          .put(`/missions/${this.missionId}`, {
            mission: {
              verified: false,
              due_date: this.missionDueDate,
              complete: false,
            },
          })
          .then((response) => this.restoreSuccess(response.data.mission))
          .catch((error) => this.restoreFail(error));
      },

      restoreSuccess(newMission) {
        this.$store.commit("setError", {
          message: "You have restored the quest, your kid will see the update shortly.",
          type: "success",
        });

        this.$store.commit("restoreMission", newMission);
        this.isRestoreModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },

      restoreFail(error) {
        console.log(error);
        this.$store.commit("setError", {
          message: this.$formatter.getErrorMsg(error),
          type: "error",
        });

        this.isRestoreModalOpen = false;
        this.$store.commit("setLoadingStatus", false);
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Mission/RestoreMissionModal.vue